import React from "react";
import { Translate } from "react-redux-i18n";
import { Link } from "react-router-dom";
import "./styles/WallSidebar.css";

function WallMenu() {
  return (
    <nav className="wall-sidebar-card">
      <div className="wall-sidebar-card-header">
        <Translate value="ads" />
      </div>
      <div className="wall-sidebar-nav">
        <span className="wall-sidebar-section-label">
          <Translate value="ads" />
        </span>
        <Link to="/home" className="wall-sidebar-link">
          <Translate value="ads_group" />
        </Link>
        <Link to="/wall" className="wall-sidebar-link is-active">
          <Translate value="ads_recently" />
        </Link>
      </div>
    </nav>
  );
}

export default WallMenu;
